export function maskEmail(email) {
  if (!email || typeof email !== 'string') {
    return '';
  }
  const [name, domain] = email.split('@');

  if (!name || !domain) return '';


  if (name.length <= 2) {
    return name + '@' + domain;
  }

  const lastStr = name.slice(2, name.length);

  return name.slice(0, 2) + '****' + lastStr.slice((Math.max(0, lastStr.length - 3)), lastStr.length) + '@' + domain;
}